import {SET_EDIT_POPUP, SET_NEW_POPUP, CLOSE_POPUP} from '../constants/popup-constants'
import {CREATE_NEW_DRAFT_CATEGORY, SAVE_CATEGORY_CHANGES} from '../constants/drafts-constants';

const initState = {
    popupMode : undefined,
    draftID: undefined,
    activePopup: false
};

export default function popup(state = initState, action) {
    switch(action.type){
        case SET_NEW_POPUP:
            return {
            ...state, 
                popupMode: 'create',
                activePopup: true
            };
        case SET_EDIT_POPUP:
            return {
            ...state,
                popupMode: 'edit',
                activePopup: true,
                draftID: action.id
            };
        case CLOSE_POPUP:
            return {
            ...state,
                activePopup: false,
                draftID: undefined,
                popupMode: undefined
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/_app/drafts/reducers/popup_reducer.js